import { Component, OnInit } from '@angular/core';
import { LoaderService } from '@tmhcc-ng-lib/framwork/loader';
import {
  RequestAccessContentService,
  CommonContentService
} from '@tmhcc-ng-lib/content-service';

@Component({
  selector: 'ae-thank-you',
  templateUrl: './thank-you.component.html',
  styleUrls: ['./thank-you.component.scss']
})
export class ThankYouComponent implements OnInit {
  pageTitle: string;
  pageDescription: string;
  pageText: string;
  constructor(
    private loaderService: LoaderService,
    private SiteCoreData: RequestAccessContentService,
    private commonContentService: CommonContentService
  ) {}

  ngOnInit(): void {
    this.commonContentService.setPageTitle();
    this.loaderService.show();
    this.requestAccessSiteCoreData();
  }
  requestAccessSiteCoreData() {
    this.SiteCoreData.data$.subscribe(res => {
      if (res) {
        this.loaderService.hide();
        this.pageTitle = res.data[0].heading;
        this.pageText = res.data[0].text;
      }
    });
  }
}
